import { getContent } from "../../Core/Content/store";
export const getContactChannelsFn = () => getContent("contact").channels;
export const getContactPromptsFn = () => getContent("contact").prompts;
